import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["handlers", "getters"],
  _excluded2 = ["handlers"];
import React from 'react';
import { CONTEXT_COMPONENT } from "../types/symbols.mjs";
export var CHILDREN_COMPONENT = Symbol('CHILDREN_COMPONENT');
var CHILDREN_SELF = Symbol('CHILDREN_SELF');
var GETTER_REG = /^get[\w]+Props$/;
function splitPropsAndGetters(props) {
  return Object.entries(props).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    if (GETTER_REG.exec(key) === null) {
      acc.props[key] = value;
    } else {
      acc.getters[key] = value;
    }
    return acc;
  }, {
    props: {},
    getters: {}
  });
}
function getterToArray(getter) {
  if (!Array.isArray(getter)) {
    return typeof getter === 'function' ? [getter] : [];
  }
  return getter;
}
function mergeObjects() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var core = _objectSpread(_objectSpread({}, a), b);
  return Object.keys(core).reduce(function (acc, key) {
    a[key] = getterToArray(a[key]);
    b[key] = getterToArray(b[key]);
    acc[key] = [].concat(_toConsumableArray(a[key]), _toConsumableArray(b[key]));
    return acc;
  }, {});
}
function assignGettersChain(getters) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return getters.reduce(function (acc, getter) {
      return getter(acc);
    }, props);
  };
}
function createChildren(Context, contexts) {
  var Children = function Children() {
    var children = Children.origin;
    if (typeof children === 'function') {
      var _reduce = [].concat(_toConsumableArray(contexts), [Context]).reduce(function (acc, ctx) {
          var _ref3 = React.useContext(ctx),
            handlers = _ref3.handlers,
            propsAndGetters = _objectWithoutProperties(_ref3, _excluded2);
          var _splitPropsAndGetters = splitPropsAndGetters(propsAndGetters),
            props = _splitPropsAndGetters.props,
            getters = _splitPropsAndGetters.getters;
          return Object.assign({}, acc, _objectSpread({
            handlers: Object.assign({}, acc.handlers, handlers),
            getters: mergeObjects(acc.getters, getters)
          }, props));
        }, Children.props),
        _reduce$handlers = _reduce.handlers,
        handlers = _reduce$handlers === void 0 ? {} : _reduce$handlers,
        _reduce$getters = _reduce.getters,
        getters = _reduce$getters === void 0 ? {} : _reduce$getters,
        props = _objectWithoutProperties(_reduce, _excluded);
      var mergedGetters = Object.entries(getters).reduce(function (acc, _ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];
        acc[key] = assignGettersChain(value);
        return acc;
      }, {});
      return children(_objectSpread(_objectSpread({}, props), mergedGetters), handlers);
    } else if (children === undefined) {
      return null;
    }
    return children;
  };
  Children.origin = null;
  Children.props = {};
  Children[CHILDREN_COMPONENT] = true;
  return Children;
}
function Enhancement(Context, parent) {
  return {
    init: function init() {
      var contexts = (Array.isArray(parent) ? parent : [parent]).map(function (component) {
        return component[CONTEXT_COMPONENT];
      }).filter(Boolean);
      this[CHILDREN_SELF] = createChildren(Context, contexts);
    },
    asProps: function asProps(props) {
      // TODO: learn the reason what it was used for (by lsroman)
      // this[CHILDREN_SELF].origin = _Children ? _Children.origin : children;
      this[CHILDREN_SELF].origin = props.children;
      this[CHILDREN_SELF].props = props;
      return _objectSpread(_objectSpread({}, props), {}, {
        Children: this[CHILDREN_SELF]
      });
    }
  };
}
export default Enhancement;
//# sourceMappingURL=Children.mjs.map